import {
  SUPERSET_TOTAL_BOOKINGS_COUNT,
  SUPERSET_TOTAL_BOOKINGS_COUNT_SUCCESS,
  SUPERSET_TOTAL_BOOKINGS_COUNT_ERROR,
  SUPERSET_TOTAL_BOOKINGS_COUNT_EMPTY,
} from '../../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SupersetTotalBookingsCount = (state = initialState, action) => {
  switch (action.type) {
    case SUPERSET_TOTAL_BOOKINGS_COUNT:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SUPERSET_TOTAL_BOOKINGS_COUNT_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SUPERSET_TOTAL_BOOKINGS_COUNT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SUPERSET_TOTAL_BOOKINGS_COUNT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SupersetTotalBookingsCount;
